export const host = "https://carlsberg-qa-bp.bpower2.com/index.php";  // QA
//export const host = "https://app.carlsbergpolska-biznesportal.pl/index.php"; // PROD